import { Toast, Dialog } from 'vant'
import store from '@/store'
import router from '@/router'

export default {
	// 登录失效时的处理
	loginFailure(cb = null) {
		Dialog.alert({
			title: '温馨提示',
			message: '登录失效，请重新登录'
		}).then(async () => {
			cb && cb()
			store.commit('router/SET_REDIRECT', router.currentRoute.fullPath)
			await router.replace({
				path: '/account/login',
				query: {
					type: 'again'
				}
			})
		})
	},
	loading(message = '加载中...') {
		Toast.loading({
			message,
			forbidClick: true,
			loadingType: 'spinner',
			duration: 0
		})
	},
	// 给data 赋值
	dataAssign(params, data, cb) {
		Object.keys(params).forEach(item => cb(item, data[item] || params[item]))
	},
	isArray(val) {
		if (!Array.isArray) {
			return Object.prototype.toString.call(val) === '[object Array]'
		}
		return Array.isArray(val)
	},
	isNumber(val) {
		if (typeof val === 'number' && !Number.isNaN(val)) {
			return true
		}
		return false
	},
	isString(val) {
		return typeof val === 'string'
	},
	/**
	 * 截取字符串
	 * @param { string } val 要处理的字符串
	 * @param { string | index | array } reg 索引或关键字
	 * @param { boolean } isLast 是否从后检索
	 * @returns {string|null}
	 */
	substrLastIndex(val, reg, isLast = false) {
		if (!this.isString(val)) return null
		if (this.isArray(reg)) return val.substring(reg[0], reg[1])
		if (this.isNumber(reg)) return val.substring(0, reg)
		if (isLast) return val.substring(0, val.lastIndexOf(reg))
		return val.substring(0, val.indexOf(reg))
	},
	// 日期格式化 带上年月日
	vantDateTimePickerFormatter(type, val) {
		switch (type) {
			case 'year':
				return val + '年'
			case 'month':
				return val + '月'
			case 'day':
				return val + '日'
			case 'hour':
				return val + '时'
			case 'minute':
				return val + '分'
			default:
				return val
		}
	},
	// 服务包服务项的有效期计算
	serviceItemValidity(lifespan) {
		if (lifespan) {
			const m = Math.floor(lifespan / 30)
			const d = lifespan - m * 30
			if (m <= 0) {
				return `${lifespan}天`
			}
			if (d > 0) {
				return `${m}个月零${d}天`
			}
			return `${m}个月`
		}
		return ``
	},
	clearDialog() {
		if (document.querySelector('.van-dialog')) {
			document.querySelector('.van-dialog').remove()
		}
	},
	phoneType: function () {
		//Android终端
		let isAndroid = /(Android)/i.test(navigator.userAgent) //Ios终端
		let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
		return {
			isAndroid: isAndroid,
			isiOS: isiOS
		}
	},
	getTag(valObj) {
		let patientTag = []
		let obj = [
			{ key: 'bmi', judge: ['>', 24], tag: '超重或肥胖' },
			{ key: 'cigs', judge: ['=', 1], tag: '吸烟' },
			{ key: 'drink', judge: ['=', 1], tag: '饮酒' },
			{ key: 'diet', judge: ['=', 1], tag: '饮食不均衡' },
			{ key: 'activity', judge: ['=', 1], tag: '缺少运动' },
			{ key: 'stress', judge: ['=', 1], tag: '压力过大' },
			{ key: 'familys', judge: ['=', 1], tag: '家族病史' },
			{ key: 'sbp', judge: ['>', 140], tag: '高血压' },
			{ key: 'dm', judge: ['>', 0], tag: '糖尿病' },
			{ key: 'cvd', judge: ['>', 0], tag: '心脑血管疾病' },
			{ key: 'af', judge: ['>', 0], tag: '房颤' },
			{ key: 'lvh', judge: ['=', 1], tag: '左心室肥厚' },
			{ key: 'cognitive', judge: ['=', 1], tag: '认知障碍' },
			{ key: 'poor_memory', judge: ['=', 1], tag: '记忆力差' },
			{ key: 'injury', judge: ['>', 0], tag: '创伤性脑损伤' },
			{ key: 'smokingHistory', judge: ['=', '是'], tag: '吸烟' },
			{ key: 'mainDiagnosis', judge: ['=', '缺血性卒中（脑梗死）'], tag: '缺血性卒中' },
			{ key: 'mainDiagnosis', judge: ['=', '出血性卒中（脑溢血、脑出血）'], tag: '出血性卒中' },
			{ key: 'mainDiagnosis', judge: ['=', '短暂性脑缺血发作（TIA）'], tag: '短暂性脑缺血发作' },
			{ key: 'diseaseHistoryList', judge: ['indexOf', '短暂性脑缺血发作（TIA)'], tag: '短暂性脑缺血发作' },
			{ key: 'diseaseHistoryList', judge: ['indexOf', '房颤'], tag: '心源性卒中' },
			{ key: 'diseaseHistoryList', judge: ['indexOf', '冠心病'], tag: '心源性卒中' },
			{ key: 'diseaseHistoryList', judge: ['indexOf', '心脏病'], tag: '心脏病' },
			{ key: 'diseaseHistoryList', judge: ['indexOf', '糖尿病'], tag: '糖尿病' },
			{ key: 'diseaseHistoryList', judge: ['indexOf', '高血压'], tag: '高血压' },
			{ key: 'diseaseHistoryList', judge: ['indexOf', '血脂异常'], tag: '血脂异常' }
		]
		obj.map(v => {
			if (patientTag.indexOf(v.tag) === -1) {
				if (v.judge[0] === '>') {
					if (valObj[v.key] > v.judge[1]) {
						patientTag.push(v.tag)
					}
				}
				if (v.judge[0] === '=') {
					if (valObj[v.key] === v.judge[1]) {
						patientTag.push(v.tag)
					}
				}
				if (v.judge[0] === 'indexOf' && valObj[v.key]) {
					if (valObj[v.key].indexOf(v.judge[1]) > -1) {
						patientTag.push(v.tag)
					}
				}
			}
		})
		return JSON.stringify(patientTag)
	}
}
